import type { WritingExpressionItem } from '../writingExpressionBank';

/** English writing scaffolds — discourse relations; shared by IELTS / TOEFL. */
export const ENGLISH_WRITING_EXPRESSIONS: readonly WritingExpressionItem[] = [
  // introduce
  { id: 'en-introduce-1', category: 'introduce', text: 'To begin with,', gloss: '首先' },
  { id: 'en-introduce-2', category: 'introduce', text: 'First of all,', gloss: '第一' },
  { id: 'en-introduce-3', category: 'introduce', text: 'This essay will discuss…', gloss: '本文将讨论…' },
  { id: 'en-introduce-4', category: 'introduce', text: 'In recent years,', gloss: '近年来' },
  { id: 'en-introduce-5', category: 'introduce', text: 'Dear Sir or Madam,', gloss: '尊敬的先生/女士（书信开场）' },
  // continue
  { id: 'en-continue-1', category: 'continue', text: 'Next,', gloss: '接下来' },
  { id: 'en-continue-2', category: 'continue', text: 'Turning to…,', gloss: '接下来谈…' },
  { id: 'en-continue-3', category: 'continue', text: 'Another point is that…', gloss: '另一点是…' },
  { id: 'en-continue-4', category: 'continue', text: 'In this regard,', gloss: '在这方面' },
  // finally
  { id: 'en-finally-1', category: 'finally', text: 'Finally,', gloss: '最后' },
  { id: 'en-finally-2', category: 'finally', text: 'Last but not least,', gloss: '最后同样重要的是' },
  { id: 'en-finally-3', category: 'finally', text: 'Ultimately,', gloss: '最终' },
  // cause_reason
  { id: 'en-cause-reason-1', category: 'cause_reason', text: 'Because', gloss: '因为' },
  { id: 'en-cause-reason-2', category: 'cause_reason', text: 'Since', gloss: '既然 / 由于' },
  { id: 'en-cause-reason-3', category: 'cause_reason', text: 'Due to', gloss: '由于…' },
  { id: 'en-cause-reason-4', category: 'cause_reason', text: 'This is largely because…', gloss: '这很大程度上是因为…' },
  // cause_result
  { id: 'en-cause-result-1', category: 'cause_result', text: 'Therefore,', gloss: '因此' },
  { id: 'en-cause-result-2', category: 'cause_result', text: 'As a result,', gloss: '结果是' },
  { id: 'en-cause-result-3', category: 'cause_result', text: 'Consequently,', gloss: '因而' },
  { id: 'en-cause-result-4', category: 'cause_result', text: 'For this reason,', gloss: '基于这一原因' },
  // contrast_turn
  { id: 'en-contrast-turn-1', category: 'contrast_turn', text: 'However,', gloss: '然而' },
  { id: 'en-contrast-turn-2', category: 'contrast_turn', text: 'Nevertheless,', gloss: '尽管如此' },
  { id: 'en-contrast-turn-3', category: 'contrast_turn', text: 'On the other hand,', gloss: '另一方面' },
  { id: 'en-contrast-turn-4', category: 'contrast_turn', text: 'Yet', gloss: '然而 / 却' },
  // contrast_concede
  { id: 'en-contrast-concede-1', category: 'contrast_concede', text: 'Although', gloss: '虽然' },
  { id: 'en-contrast-concede-2', category: 'contrast_concede', text: 'Even though', gloss: '即使' },
  { id: 'en-contrast-concede-3', category: 'contrast_concede', text: 'While it is true that…,', gloss: '诚然…' },
  { id: 'en-contrast-concede-4', category: 'contrast_concede', text: 'Admittedly,', gloss: '不可否认' },
  // parallel_add
  { id: 'en-parallel-add-1', category: 'parallel_add', text: 'In addition,', gloss: '另外' },
  { id: 'en-parallel-add-2', category: 'parallel_add', text: 'Furthermore,', gloss: '此外' },
  { id: 'en-parallel-add-3', category: 'parallel_add', text: 'Moreover,', gloss: '而且' },
  { id: 'en-parallel-add-4', category: 'parallel_add', text: 'Also,', gloss: '也' },
  // parallel_choice
  { id: 'en-parallel-choice-1', category: 'parallel_choice', text: 'Either… or…', gloss: '要么…要么…' },
  { id: 'en-parallel-choice-2', category: 'parallel_choice', text: 'Alternatively,', gloss: '或者 / 另一种做法' },
  { id: 'en-parallel-choice-3', category: 'parallel_choice', text: 'Or else', gloss: '否则' },
  // progressive
  { id: 'en-progressive-1', category: 'progressive', text: 'What is more,', gloss: '更重要的是' },
  { id: 'en-progressive-2', category: 'progressive', text: 'More importantly,', gloss: '更重要的是' },
  { id: 'en-progressive-3', category: 'progressive', text: 'Not only… but also…', gloss: '不仅…而且…' },
  // compare
  { id: 'en-compare-1', category: 'compare', text: 'Similarly,', gloss: '同样地' },
  { id: 'en-compare-2', category: 'compare', text: 'Likewise,', gloss: '类似地' },
  { id: 'en-compare-3', category: 'compare', text: 'In the same way,', gloss: '以同样的方式' },
  // juxtapose
  { id: 'en-juxtapose-1', category: 'juxtapose', text: 'In contrast,', gloss: '相比之下' },
  { id: 'en-juxtapose-2', category: 'juxtapose', text: 'By contrast,', gloss: '对照来看' },
  { id: 'en-juxtapose-3', category: 'juxtapose', text: 'Unlike…,', gloss: '与…不同' },
  // exemplify
  { id: 'en-exemplify-1', category: 'exemplify', text: 'For example,', gloss: '例如' },
  { id: 'en-exemplify-2', category: 'exemplify', text: 'For instance,', gloss: '比如' },
  { id: 'en-exemplify-3', category: 'exemplify', text: 'Such as', gloss: '诸如' },
  { id: 'en-exemplify-4', category: 'exemplify', text: 'To illustrate,', gloss: '举例说明' },
  // exception
  { id: 'en-exception-1', category: 'exception', text: 'Except for', gloss: '除…以外' },
  { id: 'en-exception-2', category: 'exception', text: 'Apart from', gloss: '除去…' },
  { id: 'en-exception-3', category: 'exception', text: 'With the exception of', gloss: '唯一例外是…' },
  // emphasize
  { id: 'en-emphasize-1', category: 'emphasize', text: 'It is worth noting that…', gloss: '值得注意的是…' },
  { id: 'en-emphasize-2', category: 'emphasize', text: 'In particular,', gloss: '特别是' },
  { id: 'en-emphasize-3', category: 'emphasize', text: 'Above all,', gloss: '尤其 / 最重要的是' },
  // condition
  { id: 'en-condition-1', category: 'condition', text: 'If', gloss: '如果' },
  { id: 'en-condition-2', category: 'condition', text: 'Provided that', gloss: '只要…' },
  { id: 'en-condition-3', category: 'condition', text: 'Unless', gloss: '除非' },
  { id: 'en-condition-4', category: 'condition', text: 'In the event that', gloss: '倘若' },
  // summarize
  { id: 'en-summarize-1', category: 'summarize', text: 'In conclusion,', gloss: '总之' },
  { id: 'en-summarize-2', category: 'summarize', text: 'To sum up,', gloss: '概括来说' },
  { id: 'en-summarize-3', category: 'summarize', text: 'Overall,', gloss: '总体而言' },
  { id: 'en-summarize-4', category: 'summarize', text: 'Taking everything into account,', gloss: '综合考虑' },
  // purpose
  { id: 'en-purpose-1', category: 'purpose', text: 'In order to', gloss: '为了…' },
  { id: 'en-purpose-2', category: 'purpose', text: 'So as to', gloss: '以便…' },
  { id: 'en-purpose-3', category: 'purpose', text: 'With the aim of', gloss: '目的在于…' },
  // restate
  { id: 'en-restate-1', category: 'restate', text: 'In other words,', gloss: '换言之' },
  { id: 'en-restate-2', category: 'restate', text: 'That is to say,', gloss: '也就是说' },
  { id: 'en-restate-3', category: 'restate', text: 'To put it another way,', gloss: '换种说法' },
  // temporal
  { id: 'en-temporal-1', category: 'temporal', text: 'Then', gloss: '然后' },
  { id: 'en-temporal-2', category: 'temporal', text: 'Previously,', gloss: '此前' },
  { id: 'en-temporal-3', category: 'temporal', text: 'Subsequently,', gloss: '随后' },
  { id: 'en-temporal-4', category: 'temporal', text: 'Meanwhile,', gloss: '与此同时' },
  // basis
  { id: 'en-basis-1', category: 'basis', text: 'According to', gloss: '根据…' },
  { id: 'en-basis-2', category: 'basis', text: 'Based on', gloss: '基于…' },
  { id: 'en-basis-3', category: 'basis', text: 'In light of', gloss: '鉴于…' },
  { id: 'en-basis-4', category: 'basis', text: 'Given that…', gloss: '考虑到…' },
];
